import { render, staticRenderFns } from "./RawModel.vue?vue&type=template&id=6bce2956&scoped=true"
import script from "./RawModel.vue?vue&type=script&lang=js"
export * from "./RawModel.vue?vue&type=script&lang=js"
import style0 from "./RawModel.vue?vue&type=style&index=0&id=6bce2956&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bce2956",
  null
  
)

export default component.exports